import { render, staticRenderFns } from "./default-body-loader.vue?vue&type=template&id=fc2c7c18"
import script from "./default-body-loader.vue?vue&type=script&lang=js"
export * from "./default-body-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports